// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fmFIOBIEIsGVklfDY3X6 {
	padding: 20px 32px;
	box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.04);
}
.JB_z79bs08SOvc9d_AFJ {
	height: 28px;
	width: 28px;
	flex-shrink: 0;
}
.RvgB1rJN6yMpwBGP3ZtV {
	align-items: center;
	display: flex;
	gap: 10px;
}
.PmOHns4TSacAwS_jTXrg {
	height: 36px;
	width: 130px;
}
@media (max-width: 767px) {
.PmOHns4TSacAwS_jTXrg {
		height: 40px;
}
	}
`, "",{"version":3,"sources":["webpack://./src/components/SISAmountInput/SISAmountInput.pcss"],"names":[],"mappings":"AAEA;CACC,kBAAkB;CAClB,4CAA4C;AAC7C;AAEA;CACC,YAAY;CACZ,WAAW;CACX,cAAc;AACf;AAEA;CACC,mBAAmB;CACnB,aAAa;CACb,SAAS;AACV;AAEA;CACC,YAAY;CACZ,YAAY;AAKb;AAHC;AAJD;EAKE,YAAY;AAEd;CADC","sourcesContent":["@import './../../stylesheets/media-queries.pcss';\n\n.input {\n\tpadding: 20px 32px;\n\tbox-shadow: 0px 4px 16px rgba(0, 0, 0, 0.04);\n}\n\n.sisIcon {\n\theight: 28px;\n\twidth: 28px;\n\tflex-shrink: 0;\n}\n\n.helper {\n\talign-items: center;\n\tdisplay: flex;\n\tgap: 10px;\n}\n\n.getTokens {\n\theight: 36px;\n\twidth: 130px;\n\n\t@media (--mobile) {\n\t\theight: 40px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": `fmFIOBIEIsGVklfDY3X6`,
	"sisIcon": `JB_z79bs08SOvc9d_AFJ`,
	"helper": `RvgB1rJN6yMpwBGP3ZtV`,
	"getTokens": `PmOHns4TSacAwS_jTXrg`
};
export default ___CSS_LOADER_EXPORT___;
